import { ContextualGraphComponent } from './contextual-graph.component';

export default angular
  .module('sfMobile.components.contextualGraph', [
    'sfMobile.components.radarGraph',
    'sfMobile.components.scatterGraph',
    'sfMobile.services.chart',
  ])
  .component('sfContextualGraph', ContextualGraphComponent).name;
